import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  connect() {
    $(".js-search-handle-radio-input").prop("disabled", !$(".js-search-handle-radio").prop("checked"));
  }

  radioset(e) {
    const target = $(e.currentTarget);

    if (target.hasClass("js-search-handle-radio")) {
      $(".js-search-handle-radio-input").prop("disabled", false);
    } else {
      $(".js-search-handle-radio-input").prop("disabled", true);
    }
  }

  sort() {
    $("form.input-sort").submit();
  }
}
